import type { DealOption } from './types.ts';

export const getDealId = (deal: DealOption) => deal.deal_id || deal.id;

export const getDealLabel = (deal: DealOption) => deal.name;

export const getDealKey = (deal: DealOption) => deal.id;

export const isSameDeal = (option: DealOption, value: DealOption) => option.id === value.id;

export const skipClientFiltering = (options: DealOption[]) => options;
